import { UserStore } from "@jog/react-components";
const store = new UserStore();
export default store;
